import { get, postJSON, del, post } from '../utils/axios'
import getUserInfo from '../utils/getUserInfo'

// 我的钱包-累计提现记录列表
interface myWalletWithdrawDetailListProps {
    endTime?: string //截止日期
    page?: string | number //当前页
    platformPk?: string //个人平台账号pk
    size?: string | number //每页大小
    startTime?: string //开始日期
    type?: string //提现类型 0-微信零钱 1-银行卡
}

export const getMyWalletWithdrawDetailList = (options:myWalletWithdrawDetailListProps) => postJSON('/payApi/personalAccount/MyWalletWithdrawDetailList', options)

// 提现银行新增/编辑
interface bankCfgProps {
    bankCardholder?: string //银行持卡人
    bankCardholderCardId?: string //银行持卡人身份证
    bankId?: string //银行ID
    bankName?: string //银行名称
    bankNum?: string //银行卡号
    bankPhone?: string //银行预留手机号
    createTime?: string //创建时间
    pk?: string //ID
    platformPk?: string //平台用户pk
    updateTime?: string //更新时间
}

export const getBankCfg = (options:bankCfgProps) => postJSON('/payApi/personalAccount/bankCfg', options)

// 我的收益业务类型列表
interface businessTypeStatisticsProps {
    businessType?: string //业务类型PK
    endTime?: string //截止日期
    intransitStatus?: string //在途状态 0-否 1-是
    page?: string | number //当前页
    platformPk?: string //个人平台账号pk
    size?: string | number //每页大小
    startTime?: string //开始日期
}

export const getBusinessTypeStatistics = (options:businessTypeStatisticsProps) => postJSON('/payApi/personalAccount/businessTypeStatistics', options)

// 收益排名列表
interface incomeRankProps {
    businessType?: string //业务类型PK
    endTime?: string //截止日期
    intransitStatus?: string //在途状态 0-否 1-是
    page?: string | number //当前页
    platformPk?: string //个人平台账号pk
    size?: string | number //每页大小
    startTime?: string //开始日期
}

export const getIncomeRank = (options:incomeRankProps) => postJSON('/payApi/personalAccount/incomeRank', options)

// 我的钱包-累计收入统计
interface incomeStatisticsProps {
    businessType?: string //业务类型
    endTime?: string //截止日期
    page?: string | number //当前页
    platformPk?: string //个人平台账号pk
    size?: string | number //每页大小
    startTime?: string //开始日期
    type?: string //类型0-收入 1-支出
}

export const getIncomeStatistics = (options:incomeStatisticsProps) => postJSON('/payApi/personalAccount/incomeStatistics', options)

// 我的钱包-收入类型列表
interface incomeTypeListProps {
    businessType?: string //业务类型
    endTime?: string //截止日期
    page?: string | number //当前页
    platformPk?: string | number //个人平台账号pk
    size?: string | number //每页大小
    startTime?: string //开始日期
    type?: string | number //类型0-收入 1-支出
}

export const getIncomeTypeList = (options:incomeTypeListProps) => postJSON('/payApi/personalAccount/incomeTypeList', options)

// 我的收益业务来源统计列表
interface myIncomeBusinessTypeStatisticsProps {
    businessType?: string //业务类型PK
    endTime?: string //截止日期
    intransitStatus?: string //在途状态 0-否 1-是
    page?: string | number //当前页
    platformPk?: string //个人平台账号pk
    size?: string | number //每页大小
    startTime?: string //开始日期
}

export const getMyIncomeBusinessTypeStatistics = (options:myIncomeBusinessTypeStatisticsProps) => postJSON('/payApi/personalAccount/myIncomeBusinessTypeStatistics', options)

// 我的收益列表
interface myIncomeDetailListProps {
    businessType?: string //业务类型PK
    endTime?: string //截止日期
    intransitStatus?: string //在途状态 0-否 1-是
    page?: string | number //当前页
    platformPk?: string //个人平台账号pk
    size?: string | number //每页大小
    startTime?: string //开始日期
}

export const getMyIncomeDetailList = (options:myIncomeDetailListProps) => postJSON('/payApi/personalAccount/myIncomeDetailList', options)

// 我的收益头部统计
interface myIncomeHeanderStatisticsProps {
    businessType?: string //业务类型PK
    endTime?: string //截止日期
    intransitStatus?: string //在途状态 0-否 1-是
    page?: string | number //当前页
    platformPk?: string //个人平台账号pk
    size?: string | number //每页大小
    startTime?: string //开始日期
}

export const getMyIncomeHeanderStatistics = (options:myIncomeHeanderStatisticsProps) => postJSON('/payApi/personalAccount/myIncomeHeanderStatistics', options)

// 我的收益排名
interface myIncomeRankProps {
    businessType?: string //业务类型PK
    endTime?: string //截止日期
    intransitStatus?: string //在途状态 0-否 1-是
    page?: string | number //当前页
    platformPk?: string //个人平台账号pk
    size?: string | number //每页大小
    startTime?: string //开始日期
}

export const getMyIncomeRank = (options:myIncomeRankProps) => postJSON('/payApi/personalAccount/myIncomeRank', options)

// 我的钱包头部统计
export const getMyWalletHeanderStatistics = () => post('/payApi/personalAccount/myWalletHeanderStatistics', { platformPk:getUserInfo().pk })

// 提现方式：微信零钱绑定信息
export const getPersonalAccountBindWx = () => post('/payApi/personalAccount/personalAccountBindWx', { platformPk:getUserInfo().pk })

// 我的钱包+我的收益统计
export const getPersonalAccountStatistics = () => postJSON('/payApi/personalAccount/personalAccountStatistics', { platformPk:getUserInfo().pk })

// 我的钱包-累计提现统计
interface personalWithdrawStatisticsProps {
    endTime?: string //截止日期
    page?: string | number //当前页
    platformPk?: string //个人平台账号pk
    size?: string | number //每页大小
    startTime?: string //开始日期
    type?: string //提现类型 0-微信零钱 1-银行卡
}
export const getPersonalWithdrawStatistics = (options:personalWithdrawStatisticsProps) => postJSON('/payApi/personalAccount/personalWithdrawStatistics', options)

// 我的钱包收支记录列表
interface selectAccountIncomeExpenseDetailListProps {
    businessType?: string //业务类型
    endTime?: string //截止日期
    page?: string | number //当前页
    platformPk?: string //个人平台账号pk
    size?: string | number //每页大小
    startTime?: string //开始日期
    type?: string //类型0-收入 1-支出
}
export const getSelectAccountIncomeExpenseDetailList = (options:selectAccountIncomeExpenseDetailListProps) => postJSON('/payApi/personalAccount/selectAccountIncomeExpenseDetailList', options)

// 提现方式：银行卡列表
export const getSelectBankList = () => post('/payApi/personalAccount/selectBankList', { platformPk:getUserInfo().pk })

// 个人账户提现申请
interface withdrawProps {
    amount?: string //提现金额
    bankCardholder?: string //银行持卡人
    bankCardholderCardId?: string //银行持卡人身份证
    bankId?: string //银行ID(转入银行卡必须)
    bankName?: string //银行名称(转入银行卡必须)
    bankNum?: string //银行卡号(转入银行卡必须)
    bankPhone?: string //银行预留手机号
    name?: string //提现申请人姓名
    openid?: string //微信openid(转入微信零钱必须)
    payee?: string //提现到零钱收款人名称(转入微信零钱必须)
    phone?: string //提现申请人手机
    platformPk?: string //出纳账户类型为个人的平台账户PK
    type?: string //类型 0-微信零钱 1-银行卡
    userPk?: string //提现申请人PK
}
export const getWithdraw = (options:withdrawProps) => postJSON('/payApi/personalAccount/withdraw', options)

// 我的钱包-提现类型统计
interface withdrawTypeStatisticsProps {
    endTime?: string //截止日期
    page?: string | number //当前页
    platformPk?: string //个人平台账号pk
    size?: string | number //每页大小
    startTime?: string //开始日期
    type?: string //提现类型 0-微信零钱 1-银行卡
}
export const getWithdrawTypeStatistics = (options:withdrawTypeStatisticsProps) => postJSON('/payApi/personalAccount/withdrawTypeStatistics', options)